<template>
  <div class="shipping-datetime">
    <div v-background-image="'/assets/placeholder.jpg'">
      <!-- PARTNER SHIPPING BANNER -->
      <div class="partner-title-wrap py10 background" v-background-image="banner">
        <p class="h4 weight-700 px10 my10 summary-partner align-center cl-white">
          {{ $t('Receiving option from ') }}
          <span class="underline relative medium">{{ group.partner.name }}</span>
        </p>
        <div class="summary px40 cl-white serif my10 ">
          <div class="row weight-700 middle-xs mb10">
            <div class="col-xs inline-flex fs16 total-price-label">
              {{ $t('In the amount of') }}
              <span class="separator col-xs ml10" />
            </div>
            <div class="align-right fs16 weight-700 total-price-value bold">
              {{ group.subtotal | price }}
            </div>
          </div>
          <div class="row weight-700 middle-xs mb10" v-if="shippingMethod !== 'pickup'">
            <div class="col-xs inline-flex fs16 total-price-label">
              {{ $t('Delivery') }}
              <span class="separator col-xs ml10" />
            </div>
            <template>
              <div v-if="shippingMethod === 'freeshipping'"
                   class="align-right fs16 bold total-price-value bold"
              >
                {{ $t('Free Delivery') }}
              </div>
              <div v-else class="align-right fs16 bold total-price-value bold">
                <order-delivery-price :price="getDeliveryPrice" @add-address="handleClickAddAddress" />
              </div>
            </template>
          </div>
        </div>
        <p @click="isShow = !isShow" class="m0">
          <span class="h5 cl-white underline inline-flex middle-xs pointer" v-if="!isShow">{{ $t('Show the items') }}  <span class="material-icons ml10">keyboard_arrow_down</span></span>
          <span class="h5 cl-white underline inline-flex middle-xs pointer" v-else>{{ $t('Hide the items') }}  <span class="material-icons ml10">keyboard_arrow_up</span></span>
        </p>
      </div>
      <div v-show="isShow" class="product-list-partner">
        <ul class="bg-cl-primary m0 products">
          <product v-for="(product, index) in group.items"
                   :key="product.sku + index"
                   :product="product"
                   class="py20"
          />
        </ul>
      </div>
    </div>

    <!-- CHOISE OF SHIPPING METHODS -->
    <div class="row pt20">
      <div class="col-xs-12">
        <div v-if="group.partner.display_mode === 'shop'">
          <no-product :partner="group.partner.code" />
        </div>

        <!-- radio buttons for choising shipping method -->
        <div class="center" v-if="shippingMethods.length >= 0">
          <div class="shipping-method start-xs" v-for="method in shippingMethods" :key="method.method_title">
            <div class="row">
              <div>
                <template v-if="method.method_code === 'delivery'/** && ifAmountIsNotFreeshipping **/">
                  <label class="radioStyled h5"> {{ labelForFlatrate(method.method_title) }}
                    <input v-model="shippingMethod" :value="method.method_code" :name="`shipping-method-${group.partner.code}`"
                           type="radio" @click="setShippingMethod(method.method_code)"
                    >
                    <span class="checkmark" />
                  </label>
                </template>
                <!-- PICKUP (самовивіз, крім партнера Подарунки з кодом gift) -->
                <template v-if="method.method_code === 'pickup' && !giftPartner">
                  <label class="radioStyled h5"> {{ $t(method.method_title) }} | {{ 0 | price }}
                    <input v-model="shippingMethod" :value="method.method_code" :name="`shipping-method-${group.partner.code}`"
                           type="radio" @click="setShippingMethod(method.method_code)"
                    >
                    <span class="checkmark" />
                  </label>
                </template>
              </div>
            </div>
          </div>
        </div>

        <span class="validation-error" v-if="$v.shippingMethod.$error && !$v.shippingMethod.required">
          {{ $t('Field is required') }}
        </span>
        <div v-if="shippingMethod !== 'pickup' && isAsapDeliveryAllowed && group.partner.shipping.asap_available && !availabilityTimeEnabled" class="row checkmark-custom mb10">
          <div class="col-xs-6 flex start-xs relative">
            <label class=" py10 h4 pointer w-100 flex middle-xs center-xs"
                   :class="{
                     'is-checked' : deliveryTimeOption === 'asap' && enableAsapButton,
                     'is-disabled' : isAsapDeliveryDisabled || !enableAsapButton
                   }"
            >
              <i class="material-icons orange">whatshot</i>

              <div class="delivery">
                <span>{{ $t('ASAP') }}</span><br>
                <span v-if="!isPartnerOpened">{{ partnerWorkingTime }}</span>
                <span v-else>{{ $t('up to 70 minutes') }}</span>
              </div>
              <input v-model="deliveryTimeOption" value="asap" :name="`delivery-time-option-${group.partner.code}`"
                     type="radio" :disabled="isAsapDeliveryDisabled || !enableAsapButton || !isPartnerOpened"
              >
            </label>
          </div>
          <div class="col-xs-6 flex start-xs relative">
            <label class="py10 h4 pointer w-100 flex middle-xs center-xs"
                   :class="{'is-checked' : deliveryTimeOption === 'time'}"
            >
              <i data-v-0c2f6ec6="" class="material-icons">schedule</i>
              {{ $t('Choose delivery time') }}
              <input v-model="deliveryTimeOption" value="time" :name="`delivery-time-option-${group.partner.code}`" type="radio">
            </label>
          </div>
        </div>
        <div v-if="availabilityTimeEnabled" class="h4 asap-unavailable-message mt10 bold align-center">
          {{ messageAvailableProduct }}
        </div>
        <span class="validation-error" v-if="!deliveryTimeOption">{{ $t('Field is required') }}</span>
        <div v-if="deliveryTimeOption === 'time' || shippingMethod === 'pickup' || availabilityTimeEnabled" class="row fs16 mb10 slider-container">
          <div class="date col-xs-12">
            <ul class="date-picker-wrap nav-tabs mb0">
              <li class="date-picker-elem nav-item relative pb10" v-for="(date, index) in dateTimeRanges" :key="index"
                  :class="{ 'active': toActive(index) }"
                  v-if="setDateOpen(date).length > 0"
              >
                <a class="no-underline" @click.prevent="setActive(index)">
                  <span class="day bold">{{ getMoment(index) }}</span><br>
                  <span class="month h5">{{ getMonth(index) }}</span>
                </a>
                <span v-if="toActive(index)" class="corner" />
              </li>
            </ul>
          </div>
          <div class="tab-content col-xs-12">
            <div v-for="(date, index) in dateTimeRanges" :id="index" class="date-item tab-pane" :key="index"
                 :class="{ 'active show': toActive(index) }"
            >
              <div class="time-range row center-xs">
                <div class="time-range-item col-xs-10 start-xs" v-for="(range, i) in date" :key="index + ' ' + range.value"
                     v-if="(range.status === 'open' || range.status === 'closing') && showWindowNumber > i"
                     :class="{ 'disabled-closed': range.status === 'closed' }"
                >
                  <label :class="{'radioStyled': true, 'is-checked': show == index + ' ' + range.value}"> {{ range.value }}
                    <input v-model="selectedDateTime" :disabled="range.status === 'closed'" type="radio"
                           :value="index + ' ' + range.value" :name="`time-ranges-${group.partner.code}`"
                           @click="setDeliveryTime(index, range.value)"
                    >
                    <span class="checkmark" />
                    <span class="checkmark-right" v-if="range.status === 'closed'">
                      {{ $t('Not available') }}
                    </span>
                    <span class="checkmark-right checkmark-green" v-else>
                      {{ $t('Available') }}
                    </span>
                  </label>
                </div>
                <div class="time-range-item col-xs-10 start-xs show-more">
                  <label v-if="isShowButton" @click="showNumberWindows += 5" class="radioStyled">
                    {{ $t('Show more slots') }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script async>
import { storedCartToken } from '@vue-storefront/core/modules/cart/helpers/cartTokenCookie'
import moment from 'moment';
import backgroundImage from 'theme/directives/background-image';
import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { DeliveryTime } from '@vue-storefront/core/modules/checkout/components/DeliveryTime';
import { timezoneTime, s3Path } from '@vue-storefront/core/helpers';
import { CartSummary } from '@vue-storefront/core/modules/checkout/components/CartSummary';
import { price } from '@vue-storefront/core/filters/price';

const Product = () => import(/* webpackChunkName: "vsf-product" */ './Product');
const NoProduct = () => import(/* webpackChunkName: "vsf-no-product" */ './NoProduct');

const OrderDeliveryPrice = () => import(/* webpackChunkName: "vsf-order-delivery-price" */ 'theme/components/core/blocks/Checkout/OrderDeliveryPrice.vue');

const today = timezoneTime();
today.setHours(0, 0, 0, 0);

export default {
  components: {
    Product,
    NoProduct,
    OrderDeliveryPrice
  },
  methods: {
    ...mapActions({
      getDeliveryTime: 'checkout/getDeliveryTime'
    }),
    setDateOpen (date) {
      return date.filter(open => open.status === 'open' || open.status === 'closing')
    },
    toActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      if (this.shippingMethod === 'pickup') {
        this.showNumberWindows = 9
      }
      this.activeItem = menuItem
    },
    getMoment: function (index) {
      moment.locale('uk');
      return moment(index).format('D');
    },
    getMonth: function (index) {
      this.$store.state.languages.currentLanguage === 'uk-UA' ? moment.locale('uk') : moment.locale('en')
      return moment(index).format('MMMM');
    },
    setDeliveryTime (index, value) {
      this.deliveryTime.datetime = index + ' ' + value
      this.show = index + ' ' + value
      this.sendDataToCheckout()
    },
    getResponsive () {
      return {
        350: {
          'items': 1,
          'edge-padding': 20
        },
        500: {
          'items': 2
        }
      }
    },
    getActiveDay (days) {
      let availableDays = Object.entries(days).find(day => {
        return Array.isArray(day[1]) && day[1].filter(range => range.status !== 'closed').length > 0
      })
      return availableDays ? availableDays[0] : null
    },
    checkDatetimeExisting (datetime) {
      let rangeExisting = false
      Object.entries(this.dateTimeRanges).find(day => {
        day[1].filter(range => {
          if (day[0] + ' ' + range.value === datetime && range.status !== 'closed') {
            this.activeItem = day[0]
            this.selectedDateTime = datetime
            rangeExisting = true
          }
        })
      })
      return rangeExisting
    },

    setShippingMethod (method) {
      this.shippingMethod = method
      if (this.shippingMethod === 'pickup') {
        this.deliveryTimeOption = 'time'
      }
      this.getDeliveryTime({
        partner_code: this.group.partner.code,
        location_code: this.group.partner.location_code,
        shipping_method: this.shippingMethod,
        cartId: this.cartId
      })
        .then((response) => {
          this.dateTimeRanges = response
          let dateExists = this.deliveryTime.datetime ? this.checkDatetimeExisting(this.deliveryTime.datetime) : false;
          if (!dateExists) {
            this.activeItem = this.getActiveDay(this.dateTimeRanges)
            if (this.activeItem) {
              this.setDeliveryTime(this.activeItem, this.getActiveRange);
              this.selectedDateTime = this.activeItem + ' ' + this.getActiveRange;
            } else {
              this.$store.dispatch('notification/spawnNotification', {
                type: 'error',
                message: this.$t('No delivery time slots are available for this option right now.'),
                action1: { label: this.$t('OK') }
              })
            }
          }
          this.sendDataToCheckout()
        })
        .catch(error => {
          console.error(error)
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: this.$t('Failed to load delivery times for this option. Please try again.'),
            action1: { label: this.$t('OK') }
          })
        });
    },

    labelForFlatrate (methodCode) {
      if (!this.hasAddress) {
        return this.$t(methodCode)
      }
      return `${this.$t(methodCode)} | ${price(this.getDeliveryPrice)}`
    },
    disableAsap (partner) {
      if (this.group.partner.code === partner.code) {
        this.deliveryTimeOption = 'time'
        this.deliveryTime.asap = 0
        this.enableAsapButton = false
      }
    },
    handleClickAddAddress () {
      this.$bus.$emit('scroll-to-the-address-form');
    }
  },
  mixins: [DeliveryTime, CartSummary],
  directives: {
    backgroundImage
  },
  data () {
    return {
      activeItem: 0,
      displayTimeRanges: false,
      dateTimeRanges: [],
      selectedDate: false,
      selectedDateTime: '',
      show: false,
      isShow: false,
      isShowNoProduct: false,
      deliveryTimeOption: 'asap',
      enableAsapButton: true,
      showNumberWindows: 9,
      cartId: ''
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner',
      hasAddress: 'address/getHasAddress'
    }),
    banner () {
      return s3Path(this.group.partner.banner)
    },
    getActiveRange () {
      return this.dateTimeRanges[this.activeItem].find(range => range.status !== 'closed').value
    },
    availabilityTimeEnabled () {
      return this.getGroupedByPartnerProducts.some(groupedProducts => {
        return groupedProducts.items.some(item => item.availability_time.availability_time_enable === true)
      })
    },
    isAsapDeliveryDisabled () {
      return (!this.isPartnerOpened || !this.isAsapDeliveryAllowed)
    },
    giftPartner () {
      return this.getGroupedByPartnerProducts.find(el => el.partner.code === 'gift')
    },
    ifAmountIsNotFreeshipping () {
      if (this.shippingMethods.find(method => method.method_code === 'freeshipping')) {
        return this.group.subtotal < this.freeShippingFrom
      }
      return true
    },
    isShowButton () {
      let activeDay = this.dateTimeRanges[this.activeItem]
      return this.shippingMethod === 'pickup' && !!activeDay && this.setDateOpen(activeDay).length > this.showNumberWindows
    },
    showWindowNumber () {
      let activeDay = this.dateTimeRanges && this.dateTimeRanges[this.activeItem]
      let numberShowCloseAndOpenWindows = activeDay && activeDay.length ? this.showNumberWindows + activeDay.length - this.setDateOpen(activeDay).length : 0
      return this.isShowButton && this.shippingMethod === 'pickup' ? numberShowCloseAndOpenWindows : 100
    },
    messageAvailableProduct () {
      let keys = Object.keys(this.dateTimeRanges)
      if (keys.length && (!this.dateTimeRanges[keys[0]].length || !this.dateTimeRanges[keys[0]].find(range => range.status === 'open'))) {
        let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        let day = days[new Date(keys[1]).getDay()]
        return this.$t('Shipping is not available today due to items in your cart. The nearest delivery time is ') + this.$t(day)
      }
      return this.$t('ASAP shipping is not available due to items in your cart')
    }
  },
  watch: {
    deliveryTimeOption () {
      this.sendDataToCheckout()
    },
    selectedDateTime () {
      this.sendDataToCheckout()
    }
  },
  mounted () {
    this.$bus.$emit('update-delivery-time')
    this.$nextTick(() => {
      this.cartId = storedCartToken()
      this.$bus.$on('hideAsapButton', this.disableAsap)
      this.shippingMethods.map(shipping => {
        if (shipping.method_code === 'delivery') {
          shipping.amount = this.getDeliveryPrice
        }
      })
      this.getDeliveryTime({
        partner_code: this.group.partner.code,
        location_code: this.group.partner.location_code,
        shipping_method: this.shippingMethod,
        cartId: this.cartId
      })
        .then((response) => {
          if (this.group.partner.code === 'gift') {
            let availableDays = Object.entries(response)[0]
            delete response[availableDays[0]]
          }
          if (this.group.partner.location_code === 'lutsk') {
            let availableDays = Object.entries(response)[0]
            this.dateTimeRanges = {}
            this.dateTimeRanges[availableDays[0].toString()] = {}
            this.dateTimeRanges[availableDays[0].toString()] = availableDays[1]
          } else {
            this.dateTimeRanges = response
          }
          let dateExists = false;
          if (Object.keys(this.deliveryTime).length > 0 && this.deliveryTime.constructor === Object) {
            if (this.deliveryTime.datetime) {
              dateExists = this.checkDatetimeExisting(this.deliveryTime.datetime)
            }
            if (this.deliveryTime.asap && this.isPartnerOpened && this.isAsapDeliveryAllowed && !this.availabilityTimeEnabled) {
              this.deliveryTimeOption = 'asap'
              this.deliveryTime.asap = 1
            } else {
              this.deliveryTimeOption = 'time'
              this.deliveryTime.asap = 0
            }
          }
          if (!dateExists) {
            this.activeItem = this.getActiveDay(this.dateTimeRanges)
            if (this.activeItem) {
              this.setDeliveryTime(this.activeItem, this.getActiveRange);
              this.selectedDateTime = this.activeItem + ' ' + this.getActiveRange;
            } else {
              this.$store.dispatch('notification/spawnNotification', {
                type: 'error',
                message: this.$t('No delivery time slots are available right now. Please try again later.'),
                action1: { label: this.$t('OK') }
              })
            }
          }
        })
        .catch(error => {
          console.error(error)
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: this.$t('Failed to load delivery times. Please refresh the page and try again.'),
            action1: { label: this.$t('OK') },
            hasNoTimeout: true
          })
        })
      if (!this.group.partner.shipping.asap_available || !this.isPartnerOpened || !this.isAsapDeliveryAllowed || this.availabilityTimeEnabled) {
        this.deliveryTimeOption = 'time'
        this.deliveryTime.asap = 0
      }
    })
  },
  validations: {
    shippingMethod: {
      required
    }
  },
  destroyed () {
    this.$bus.$off('hideAsapButton')
  }
}
</script>
<style lang="scss">
  .disabled-delivery {
    color: grey;
    font-weight: 700;
    display: none;
  }

  .asap-unavailable-message {
    color: #ffa500;
  }

  .shipping-datetime .checkmark-custom .disabled-delivery label {
    border: 1px solid #d0d0d0;
    color: #d0d0d0;
  }

  .date-picker-elem.active a{
    color: rgb(255, 255, 255);
  }

  .date-picker-elem.active a{
    color: rgb(255, 255, 255);
    background: #11bb2e;
    border: 1px solid #11bb2e;
  }
  .date-picker-elem a.underline:after, .date-picker-elem a:not(.no-underline):hover:after{
    height: 0;
  }
  .date-picker-elem a{
    text-transform: uppercase;
    font-weight: bold;
    text-decoration: none;
    color: #11bb2e;
    cursor: pointer;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    border: 1px solid #ebebeb;
  }
  .date-picker-elem{
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-right: 8px;

  }
  .date-picker-wrap{
    display: flex;
    overflow: auto;
    padding-left: 0;
  }
  .tab-content>.tab-pane.active {
    display: block;
    background-color: #f9f8f6;
  }
  .tab-content>.tab-pane {
    display: none;
  }

  #checkout .time-range-item .radioStyled{
    margin-bottom: 0;
    width: 100%;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-left: -12px;
    padding-left: 45px;
    color: #111;
  }
  #checkout .time-range .time-range-item .radioStyled .checkmark-right.checkmark-green{
    color: #11bb2e;
  }
  #checkout .time-range .time-range-item .radioStyled .checkmark-right{
    right: 12px!important;
    top: 12px!important;
    left: auto!important;
    position: absolute;
    color: #000;
  }
  #checkout .time-range .time-range-item .radioStyled .checkmark{
    left: 12px!important;
    top: 12px!important;
    border: 1px solid #979797;
    &:after{
      background: #11bb2e;
      top: 3px;
      left: 3px;
      width: 14px;
      height: 14px;
    }
  }
  #checkout {
    .time-range .time-range-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      color: #11bb2e;
      font-weight: bold;
      border-bottom: 1px solid #fff;
    }

    .time-range .time-range-item.disabled-closed {
      background: #cacaca;
      color: #000;
    }
  }
  .bold-store {
    font-size: 20px;
    font-weight: 700;
  }
  .shipping-datetime {
    .checkmark-custom {
      .is-checked{
        border: 1px solid #11bb2e;
        border-radius: 10px;
        background-color: #11bb2e;
        color: #fff;
        opacity: 1;
      }
      label {
        border: 1px solid #11bb2e;
        border-radius: 10px;
        color: #11bb2e;
        font-size: 13px;
        opacity: 0.5;
        .delivery{
          font-size: 13px;
        }
        i {
          margin-right: 5px;
        }
        &.is-checked {
          i {
            color: #fff;
            &.orange{
              color: #f8e71c;
            }
          }
        }
        &.is-disabled {
          border: 1px solid #f1f1f1;
          background-color: #f1f1f1;
          color: #999999;
          i {
            color: #aaa;
          }
        }
        @media (min-width: 769px) {
          font-size: 16px;
        }
      }
      input {
        opacity: 0;
        height: 0;
        position: absolute;
      }
    }
  }
  .orange{
    color: #f8e71c;
  }
  .day{
    font-size: 21px;
  }
  .corner{
    position: absolute;
    bottom: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 10px 0 10px;
    border-color: #11bb2e transparent transparent transparent;
  }
  .underline:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #ffffff;
  }
  .total-price-label {
    width: calc(100% - 110px);
  }
  .separator {
    border-bottom: 1px dashed #fff;
    height: 15px;
  }
  .total-price-value {
    padding-left: 8px;
    padding-right: 8px;
  }
  .background{
    background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)) bottom center no-repeat;
    background-size: cover;
  }
</style>
<style lang="scss" scoped>
  .tablet-width{
    @media (max-width: 991px) and (min-width: 767px){
      flex-basis: 100%;
      max-width: 100%;
    }
  }
  #checkout .radioStyled .checkmark {
    border: 1px solid #979797 !important;
    &:after{
      background: #11bb2e !important;
    }
  }
  .date-picker-elem{
    a {
      color: #000000 !important;
    }
  }
  .date-picker-elem.active {
    a{
      color: #ffffff !important;
    }
  }
  #checkout {
    .time-range-item.show-more {
      .radioStyled {
        padding-left: 13px;
        color: #11bb2e;
      }
    }
  }
  .center {
    width: fit-content;
    margin: 0 auto;
  }

  .products {
    padding: 0 8px;
  }
</style>
